import type { AuthUser, TechnicalUser } from "@/model/user";
import { useLicenseStore } from "@/store/license";
import {
  amplitudeApiKey,
  amplitudeDebug,
  amplitudeReverseProxy,
  build,
  environment,
  faroUrl,
  intercomApi,
  intercomId,
  isCloud,
  posthogApiKey,
  posthogReverseProxy,
} from "@/utils/env/Environment";
import { isFeatureEnabled, parseUrlWithoutRouter } from "@/utils/env/feature";

import { initAmplitude } from "./impl/amplitude";
import { initFaro } from "./impl/faro";
import { initIntercom } from "./impl/intercom";
import { initPosthog } from "./impl/posthog";
import { trackUserSettings } from "./track";

export function initTracking(authUser: AuthUser, user: TechnicalUser) {
  if (isCloud) {
    const userInfo = { ...authUser, ...user };
    const license = useLicenseStore().license;
    if (license.tracking) {
      const licenseInfo = {
        type: license.type,
        plan: license.plan,
        expired: useLicenseStore().isExpired,
      };
      if (amplitudeApiKey) {
        const amplitudeConfig = {
          apiKey: amplitudeApiKey,
          reverseProxy: amplitudeReverseProxy,
          build: build.hash,
          debug: amplitudeDebug,
        };
        void initAmplitude(amplitudeConfig, licenseInfo, userInfo).then(trackUserSettings);
      }
      if (posthogApiKey) {
        const posthogConfig = { apiKey: posthogApiKey, reverseProxy: posthogReverseProxy };
        void initPosthog(posthogConfig, licenseInfo, userInfo);
      }
      if (intercomId && intercomApi) {
        const intercomConfig = { id: intercomId, api: intercomApi };
        initIntercom(intercomConfig, licenseInfo, userInfo);
      }
    }
    if (faroUrl) {
      const sampleAll = isFeatureEnabled({ query: parseUrlWithoutRouter() }, "faro-sample-all");
      const faroConfig = {
        url: faroUrl,
        samplingRate: sampleAll ? 1 : 0.08,
        build: build.hash,
        environment,
      };
      void initFaro(faroConfig, userInfo);
    }
  }
}
